<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center">
        <div
            style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);">
            <div class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius:53px">
                <div class="text-center mb-5">
                    <div class="text-900 text-3xl font-medium mb-3">Bienvenid@!</div>
                    <span class="text-600 font-medium">Inicia sesión para continuar</span>
                </div>
                <form [formGroup]="form" (ngSubmit)="login()">
                    <div class="flex flex-column gap-2">
                        <label for="username" class="block text-900 font-medium text-xl mb-2">Correo Electronico</label>
                        <input pInputText id="username" formControlName="email" class="w-full" />
                        <div *ngIf="form.get('email')?.hasError('required') && form.get('email')?.touched">
                            <span class="text-danger">Correo Electronico es Requerido</span>
                        </div>
                    </div>
                    <br>
                    <div>
                        <label for="password1" class="block text-900 font-medium text-xl mb-2">Contraseña</label>
                        <p-password formControlName="password" [toggleMask]="true"
                            class="w-full md:w-30rem mb-5"></p-password>
                        <div *ngIf="form.get('password')?.hasError('required') && form.get('password')?.touched">
                            <span class="text-danger">Contraseña es Requerido</span>
                        </div>
                    </div>
                    <br>
                    <div>
                        <button pButton pRipple type="submit" label="Login" class="w-full p-3 text-xl"></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

